/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from 'src/components/common/cpds/utils/cpds-utils';
import { Typo } from 'components/common/ui';
import {cpdsMediaQueryVals, fontLineHeight, fontSize, mediaQueries} from 'components/common/cpds/token/shared/common';
import { CpdsAspectRatioType } from 'components/common/cpds/cpds-image/constants';
import { BackgroundVariants } from 'components/common/modules/v3/brand/v3-shoppable-one-up-card-carousel/components/v3-shoppable-one-up-card-carousel';

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} 

Start styles for component here
Your Styles goes here  
End styles for component here

Styles overrides - Do not Remove This Code Block
Data feed styles overrides goes here

// Your Styles goes here and use token ex: ${token?.button_primary_background_color}

*/

const getCardContentPadding = (aspectRatio: CpdsAspectRatioType) => {
  switch (aspectRatio) {
    case CpdsAspectRatioType.CPDS_4x3:
      return '32px 0';
    case CpdsAspectRatioType.CPDS_4x5:
      return '59px 0';
    case CpdsAspectRatioType.CPDS_1x1:
      return '121px 0';
    default:
      return '32px 0';
  }
};

const getDotsPosition = (aspectRatio: CpdsAspectRatioType) => {
  switch (aspectRatio) {
    case CpdsAspectRatioType.CPDS_4x3:
      return {
        bottom: '40px',
        right: '482px',
      };
    case CpdsAspectRatioType.CPDS_1x1:
      return {
        bottom: '128px',
        right: '482px',
      };
    case CpdsAspectRatioType.CPDS_4x5:
      return {
        bottom: '64px',
        right: '710px',
      };
    default:
      return {
        bottom: '40px',
        right: '482px',
      };
  }
};

export const getTertiaryTextColor = (moduleColor, tertiaryColor, defaultColor) => {
  if (moduleColor.toLowerCase() === BackgroundVariants.TERTIARY
    && tertiaryColor !== 'none') {
    return tertiaryColor;
  } else {
    return defaultColor
  }
}

export const V3ShoppableOneUpCardCarousel = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    let isTertiary = props?.moduleColor.toLowerCase() === BackgroundVariants.TERTIARY
            && token?.module_v3_shoppable_one_carousel_tertiary_arrow_color !== 'none';
    
    return css`
      .shoppable-card {
        position: relative;

        .shoppable-card_detail_area {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          @media ${mediaQueries.tablet} {
            padding-bottom: 80px;
          }
        }

        .slick-list {
          overflow: visible;

          @media ${mediaQueries.tablet} {
            overflow: hidden;
          }
        }

        .slick-arrow {
          width: 40px;
          height: 40px;
          min-height: 40px;
          border-radius: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 50%;
          ${isTertiary ? `background-color: ${token?.module_v3_shoppable_one_carousel_tertiary_arrow_color || '#FFFFFF'};` : ''};

          @media ${mediaQueries.tablet} {
            background-color: transparent;
            width: 24px;
            height: 24px;
            min-height: 24px;
            display: flex !important;
            align-items: center;
            justify-content: center;
          }

          &:before {
            display: none;

            @media ${mediaQueries.tablet} {
              display: block;
              border-width: 0 2px 2px 0;
              border-color: ${(props) => getTertiaryTextColor(props.moduleColor, token?.module_v3_shoppable_one_carousel_tertiary_text_color, (token?.module_v3_4up_carousel_dots_active_color || '#0C0E1C'))};
              width: 4.94px;
              height: 4.94px;
              padding: 2px;
            }
          }

          &.slick-prev {
            left: -21px;
            transform: translateY(-22px);

            @media ${mediaQueries.tablet} {
              left: 50%;
              right: auto;
              transform: translate(calc(-50% - 36px - 8px), 0px);
              bottom: 40px;
              top: auto;
            }
          }

          &.slick-next {
            right: -21px;
            transform: translateY(-22px);

            @media ${mediaQueries.tablet} {
              left: 50%;
              right: auto;
              transform: translate(calc(-50% + 36px + 8px), 0px);
              bottom: 40px;
              top: auto;
            }
          }
        }

        .cpds-dotted-pagination {
          position: absolute;
          bottom: ${(props) => getDotsPosition(props?.aspectRatio)?.bottom};

          @media (min-width: ${cpdsMediaQueryVals.cpds_large_lower_limit}) {
            
            display: grid;
            grid-template-columns: repeat(12, 1fr);
            gap: 40px;
            width: 100%;
            
            .magic-dots {
              margin: 0 !important;
              grid-column: 8 / span 5;
            }
          }

          @media ${mediaQueries.tablet} {
            bottom: 40px;
            right: auto;
            left: 50%;
            transform: translateX(-50%);
          }

          ul {
            li {
              height: 24px;

              &.slick-active button:before {
                font-size: 32px !important;
                color: ${(props) => getTertiaryTextColor(props.moduleColor, token?.module_v3_shoppable_one_carousel_tertiary_text_color, (token?.module_v3_shoppable_one_carousel_title_color || '#0C0E1C'))};
              }

              button {
                width: 12px;
                height: 24px;

                &:before {
                  width: 12px;
                  font-size: 24px !important;
                  color: ${(props) => getTertiaryTextColor(props.moduleColor, token?.module_v3_shoppable_one_carousel_tertiary_dots_inactive_color, '#9ca0b0')};
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                }
              }
            }
          }
        }
      }

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const ImageContainer = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      .cpds-image {
        width: 100%;
        height: auto;

        @media ${mediaQueries.tablet} {
          aspect-ratio: ${(props) => (props.aspectRatio === CpdsAspectRatioType.CPDS_4x5 ? '4 / 5' : '1 / 1')};
        }
      }

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const Card = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    let isTertiary = props?.moduleColor.toLowerCase() === BackgroundVariants.TERTIARY
    && token?.module_v3_shoppable_one_carousel_tertiary_text_color !== 'none'
    return css`
      width: 100%;
      height: 100%;
      padding: ${(props) => getCardContentPadding(props?.aspectRatio)};
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      a.cpds-meta-roman-medium-book-09 {
        ${isTertiary ? `
        background-color: ${token?.module_v3_shoppable_one_carousel_tertiary_text_color}; 
        color: ${token?.module_v3_shoppable_one_carousel_title_color || '#0C0E1C'};
        ` : ''};
      }

      @media ${mediaQueries.tablet} {
        padding: 16px 0 0;
        min-height: 280px;

        a.cpds-meta-roman-medium-book-09 {
          width: 82px;
          height: 40px;
          max-height: 40px;
          padding: 8px;
        }
      }
      
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const Title = styled(Typo.HTMLText)`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${(props) => getTertiaryTextColor(props.moduleColor, token?.module_v3_shoppable_one_carousel_tertiary_text_color, (token?.module_v3_shoppable_one_carousel_title_color || '#0C0E1C'))};
      max-width: 458px;
      
      @media ${mediaQueries.tablet} {
        font-size: ${fontSize.fontSize04} !important;
        line-height: ${fontLineHeight.fontLineHeight04} !important;
        font-weight: 250;
        max-width: 100%;
      }
      
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const LocationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 16px 0 24px 0;
  height: 16px;
  gap: 3.13px;

  @media ${mediaQueries.tablet} {
    margin: 12px 0 20px 0;
  }
`;

export const Location = styled(Typo.HTMLText)`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${(props) => getTertiaryTextColor(props.moduleColor, token?.module_v3_shoppable_one_carousel_tertiary_text_color, '#676a7d')};
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const Description = styled(Typo.HTMLText)`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      max-width: ${(props) => (props.aspectRatio === CpdsAspectRatioType.CPDS_4x5 ? '525px' : '342px')};
      display: -webkit-box;
      -webkit-line-clamp: 3; /* Limits the text to 3 lines */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      color: ${(props) => getTertiaryTextColor(props.moduleColor, token?.module_v3_shoppable_one_carousel_tertiary_text_color, (token?.module_v3_shoppable_one_carousel_description_color || '#31374F'))};

      @media ${mediaQueries.tablet} {
        max-width: 100%;
      }

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const RatingAndPrice = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 46px;

  @media ${mediaQueries.tablet} {
    height: 40px;
  }
`;

export const RatingContainer = styled.div`
  ${({
       theme: {
         styles: {cpds},
       },
       ...props
     }) => {
    const {token} = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      margin-right: 8px;
      min-width: 112px;

      p {
        color: ${(props) => getTertiaryTextColor(props.moduleColor, token?.module_v3_shoppable_one_carousel_tertiary_text_color, (token?.module_v3_shoppable_one_carousel_title_color || '#0C0E1C'))} !important;
      }

      ${(props) => props?.styleOverrides}
    `;
  }}
`;
/*

export const Rating = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${(props) =>
        props.moduleColor.toLowerCase() === BackgroundVariants.TERTIARY
          ? (token?.module_v3_shoppable_one_carousel_tertiary_rating_background_color || '#22823A')
          : '#22823A'};
      border-radius: 4px;
      padding: 8px 8.5px;
      width: 32px;
      height: 23px;
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const RatingValue = styled(Typo.HTMLText)`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${(props) => getTertiaryTextColor(props.moduleColor, token?.module_v3_shoppable_one_carousel_tertiary_rating_text_color, '#FFFFFF')};
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const RatingDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 2px;
`;

export const RatingLabel = styled(Typo.HTMLText)`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      line-height: 7px !important;
      color: ${(props) => getTertiaryTextColor(props.moduleColor, token?.module_v3_shoppable_one_carousel_tertiary_text_color, (token?.module_v3_shoppable_one_carousel_title_color || '#0C0E1C'))};
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const Reviews = styled(Typo.HTMLText)`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${(props) => getTertiaryTextColor(props.moduleColor, token?.module_v3_shoppable_one_carousel_tertiary_text_color, (token?.module_v3_shoppable_one_carousel_title_color || '#0C0E1C'))};
      ${(props) => props?.styleOverrides}
    `;
  }}
`;
*/

export const PriceInfo = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      padding-left:${(props) => props.showBorder ?  '24px' : '0'};
      gap: 4px;
      border-left: ${(props) => props.showBorder ? `1px solid ${token?.module_v3_shoppable_one_carousel_price_border_color || '#D1D5E2'}` : 'none'};
      height: 100%;

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const Price = styled(Typo.HTMLText)`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${(props) => getTertiaryTextColor(props.moduleColor, token?.module_v3_shoppable_one_carousel_tertiary_text_color, (token?.module_v3_shoppable_one_carousel_title_color || '#0C0E1C'))};

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const DateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5.88px;
  height: 16px;
`;

export const Spacer = styled.div`
  width: 10px;
  height: 24px;

  @media ${mediaQueries.tablet} {
    display: none;
  }
`;

export const Date = styled(Typo.HTMLText)`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${(props) => getTertiaryTextColor(props.moduleColor, token?.module_v3_shoppable_one_carousel_tertiary_text_color, '#676a7d')};
      
      font-weight: 500;

      span {
        font-weight: 400;
      }

      ${(props) => props?.styleOverrides}
    `;
  }}
`;
